/** KuzunekoRoom — 縦基準・枠付き動画プレーヤー */
export default function KuzunekoRoom() {
  return (
    <div style={{
      position: "fixed", inset: 0, background: "#0a0010",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      {/* 左上：戻るボタン */}
      <a
        href="#/secret-door"
        style={{
          position: "absolute", top: 16, left: 16, zIndex: 30,
          fontFamily: "monospace", fontSize: 11, letterSpacing: "0.2em",
          color: "rgba(255,255,255,0.35)", textDecoration: "none",
          background: "rgba(0,0,0,0.55)", padding: "5px 12px",
          borderRadius: 4, border: "1px solid rgba(255,255,255,0.10)",
        }}
        onMouseEnter={e => (e.currentTarget.style.color = "rgba(255,255,255,0.80)")}
        onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.35)")}
      >
        ← 戻る
      </a>

      {/* 動画ラッパー：縦90vhを基準、9:16比率 */}
      <div style={{
        position: "relative",
        height: "90vh",
        width: "calc(90vh * 9 / 16)",
        maxWidth: "96vw",
        border: "1px solid rgba(180,120,255,0.45)",
        borderRadius: 6,
        boxShadow: "0 0 0 1px rgba(120,60,220,0.25), 0 0 30px rgba(140,70,255,0.30), 0 0 70px rgba(100,40,200,0.18)",
        overflow: "hidden",
        background: "#000",
      }}>
        {/* 四隅アクセント */}
        <span style={{ position:"absolute", top:0, left:0, width:14, height:14, borderTop:"2px solid rgba(200,150,255,0.7)", borderLeft:"2px solid rgba(200,150,255,0.7)", zIndex:5, pointerEvents:"none" }} />
        <span style={{ position:"absolute", top:0, right:0, width:14, height:14, borderTop:"2px solid rgba(200,150,255,0.7)", borderRight:"2px solid rgba(200,150,255,0.7)", zIndex:5, pointerEvents:"none" }} />
        <span style={{ position:"absolute", bottom:0, left:0, width:14, height:14, borderBottom:"2px solid rgba(200,150,255,0.7)", borderLeft:"2px solid rgba(200,150,255,0.7)", zIndex:5, pointerEvents:"none" }} />
        <span style={{ position:"absolute", bottom:0, right:0, width:14, height:14, borderBottom:"2px solid rgba(200,150,255,0.7)", borderRight:"2px solid rgba(200,150,255,0.7)", zIndex:5, pointerEvents:"none" }} />

        {/* 動画 */}
        <video
          key="kuzu_room_v3"
          preload="auto"
          controls
          autoPlay
          loop
          playsInline
          style={{ display:"block", width:"100%", height:"100%", objectFit:"contain" }}
        >
          <source src="/video/kuzu_room_v3.mp4" type="video/mp4" />
        </video>
      </div>
    </div>
  );
}
